import { Validators } from '@angular/forms';
import { Component, OnInit, Output, EventEmitter, ViewChild } from '@angular/core';
import { BaseUpdateComponent, BaseDataService, InputComponent, ExchangeRateDataService, ExchangeRateData, NotificationService} from 'yt-ng-framework';
import { ActivatedRoute } from '@angular/router';
// import { NotificationsService } from 'angular2-notifications';
import { TranslateService } from '@ngx-translate/core';
import { KursDokumentStavka } from './kurs-dokument-stavka';
import { Valuta } from '../valuta/valuta';
import { NgbDate } from '@ng-bootstrap/ng-bootstrap';
// import { ToastrService } from 'ngx-toastr';


@Component({
  selector: 'yt-kurs-dokument-stavka-update',
  templateUrl: './kurs-dokument-stavka-update.component.html'
})
export class KursDokumentStavkaUpdateComponent extends BaseUpdateComponent<KursDokumentStavka> implements OnInit {
  
  constructor(
    protected activatedRoute: ActivatedRoute,
    protected baseDataService: BaseDataService,
    // protected notificationsService: NotificationsService,
    protected toastrService: NotificationService,
    protected translateService: TranslateService,
    protected exchangeRateDataService: ExchangeRateDataService
  ) {
    super(activatedRoute, baseDataService, toastrService, translateService);
  }
  
  sifraValute : string;
  loadingCompanyData:boolean = false;

  ngOnInit() {
    super.ngOnInit();  
    this.addValidatorToFc("ValutaID", Validators.required, 'required', 'KURSDOKUMENTSTAVKA.VALUTA.VALIDATION.REQUIRED');     
  } 

  editMode:boolean=false;
  SaveMaster(qq){}
  Cancel(){}
 
  onValutaSelect(value:Valuta){
    if (value)
      this.sifraValute = value.Sifra;
  }
  GetExchangeRateDataByDate(){
    let _datum : NgbDate = new NgbDate(Number(this.Parameters.get(0).get(0).Value["year"]), Number(this.Parameters.get(0).get(0).Value["month"]), Number(this.Parameters.get(0).get(0).Value["day"]));
    let datum : Date = new Date(_datum["year"], _datum["month"] - 1, _datum["day"]);
    let _datumString = datum.toISOString();
    if (datum && this.sifraValute && this.sifraValute != ""){
      this.exchangeRateDataService.GetByCurrency(Number(this.sifraValute),_datumString,_datumString, 2)
      .subscribe((data:ExchangeRateData[]) => {
        this.loadingCompanyData = false;
        if(data.length == 0){
          this.translateService.get(['NBS.KURSVALUTA.WARNING'])
            .subscribe(translate => {
              // this.notificationsService.alert(translate['NBS.KURSVALUTA.WARNING']);
              this.toastrService.info(translate['NBS.KURSVALUTA.WARNING']);
              return;
            });
      }
      else
          this.setExchangeRateData(data[0]);
      })
      // this.exchangeRateDataService.GetByDate(_datumString, Number(this.sifraValute))
      // .subscribe((data:ExchangeRateData[]) => {
      //   this.loadingCompanyData = false;
      //   if(data.length == 0){
      //     this.translateService.get(['NBS.KURSVALUTA.WARNING'])
      //       .subscribe(translate => {
      //         this.notificationsService.alert(translate['NBS.KURSVALUTA.WARNING']);
      //         return;
      //       });
      // }
      // else
      //     this.setExchangeRateData(data[0]);
      // })
    }
    else{
      this.translateService.get(['NBS.KURSVALUTA.PRAZNASIFRA.WARNING'])
            .subscribe(translate => {
              // this.notificationsService.alert(translate['NBS.KURSVALUTA.PRAZNASIFRA.WARNING']);
              this.toastrService.info(translate['NBS.KURSVALUTA.PRAZNASIFRA.WARNING']);
              return;
            });
    }
  }

  setExchangeRateData(data:ExchangeRateData){
    this.baseFormGroup.patchValue({
      VredDinK : data.BuyingRate,
      VredDinS : data.MiddleRate,
      VredDinP : data.SellingRate
      
    })
  }
}
